import React, { useState } from 'react';
import { Form, Button, Spinner, Card, Row, Col, InputGroup } from 'react-bootstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { globalErrorHandler } from '../../utils/GlobalErrorHandler';
import 'bootstrap-icons/font/bootstrap-icons.css';

const ChangePassword = () => {
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  // Toggle password visibility
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!newPassword || !confirmPassword) {
      Swal.fire('All fields are required!', '', 'warning');
      return;
    }

    if (newPassword !== confirmPassword) {
      Swal.fire('New password and confirm password do not match!', '', 'warning');
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/change-password`,
        { new_password: newPassword },
        { withCredentials: true }
      );

      if (res.data.status) {
        Swal.fire('Success', res.data.message, 'success');
        setNewPassword('');
        setConfirmPassword('');
      } else {
        Swal.fire('Error', res.data.message, 'error');
      }
    } catch (err) {
      globalErrorHandler(err, navigate);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-4">
      <h3 className="mb-4">Change Password</h3>

      <Row className="justify-content-center">
        <Col xs={12} md={10} lg={7}>
          <Card className="shadow">
            <Card.Body>
              <Form onSubmit={handleSubmit}>

                {/* New Password */}
                <Form.Group controlId="newPassword" className="mb-3">
                  <Form.Label>New Password</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type={showNew ? 'text' : 'password'}
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      placeholder="Enter new password"
                    />
                    <Button
                      variant="outline-secondary"
                      onClick={() => setShowNew(!showNew)}
                      type="button"
                    >
                      <i className={showNew ? 'bi bi-eye-slash' : 'bi bi-eye'}></i>
                    </Button>
                  </InputGroup>
                </Form.Group>

                {/* Confirm Password */}
                <Form.Group controlId="confirmPassword" className="mb-3">
                  <Form.Label>Confirm New Password</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type={showConfirm ? 'text' : 'password'}
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      placeholder="Confirm new password"
                    />
                    <Button
                      variant="outline-secondary"
                      onClick={() => setShowConfirm(!showConfirm)}
                      type="button"
                    >
                      <i className={showConfirm ? 'bi bi-eye-slash' : 'bi bi-eye'}></i>
                    </Button>
                  </InputGroup>
                </Form.Group>

                <div className="text-end">
                  <Button type="submit" variant="primary" disabled={loading}>
                    {loading ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Updating...
                      </>
                    ) : (
                      'Update Password'
                    )}
                  </Button>
                </div>

              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ChangePassword;
